module.exports = __webpack_public_path__ + "media/images/pepsi-west-a9e8815a4847d048fc54d9a303f4ae3c.png";